import { FieldObject } from '~/interfaces/field.interface';

// TODO: to rework when doing fields booleans to know when to add a field to the list of fields
export function sensorBatteryVoltage(text: string, value?: number): FieldObject {
    return { key: `${text} Battery (ADC)`, value };
}

export function detectionChamberStatus(value ?: string): FieldObject {
    return { key: 'Status Smoke Chamber', value };
}
export function batteryAlarmState(value?: string): FieldObject {
    return { key: 'Status Battery', value };
}
export function smokeDetectedStartTime(value?: number): FieldObject {
    return { key: 'Last Smoke Detected start time', value, type: 'date' };
}
export function smokeDetectedEndTime(value?: number): FieldObject {
    return { key: 'Last Smoke Detected end time', value, type: 'date' };
}
export function statusTempered(value?: boolean): FieldObject {
    return { key: 'Tampered', value, type: 'boolean' };
}
export function soundTest(value?: string): FieldObject {
    return { key: 'Sound test', value };
}
export function lastSoundTest(value?: number): FieldObject {
    return { key: 'Date last sound test', value, type: 'date' };
}

